import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import KhatianTable from "./pages/KhatianTable";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    // <BrowserRouter>
    //   <div>
    //     {/* Link to /land page */}
    //     <Link to="/land" style={{ fontSize: '20px', color: 'blue' }}>
    //       Go to Land Page
    //     </Link>

    //     <Routes>
    //       <Route path="/land" element={<KhatianTable />} />
    //     </Routes>
    //   </div>
    // </BrowserRouter>
    <KhatianTable/>
  );
}

export default App;
